import { useState } from 'react';
import type { IngredientCategory, Ritual } from '../data/ingredients';
import styles from './IngredientStation.module.css';

interface IngredientStationProps {
  category: IngredientCategory;
  ritual: Ritual;
  onChange: (key: keyof Ritual, value: string) => void;
}

export function IngredientStation({ category, ritual, onChange }: IngredientStationProps) {
  const currentValue = ritual[category.key] ?? '';
  const isPreset = category.options.some((o) => o.label === currentValue);
  const [customMode, setCustomMode] = useState(!isPreset && currentValue.length > 0);

  return (
    <fieldset className={styles.field}>
      <legend className={styles.legend}>{category.legend}</legend>
      <p className={styles.hint}>{category.hint}</p>

      {!customMode && (
        <div className={styles.chips}>
          {category.options.map((opt) => (
            <button
              key={opt.id}
              type="button"
              className={`${styles.chip} ${currentValue === opt.label ? styles.chipActive : ''}`}
              onClick={() => onChange(category.key, opt.label)}
            >
              {opt.label}
            </button>
          ))}
          {category.allowCustom && (
            <button
              type="button"
              className={styles.customToggle}
              onClick={() => setCustomMode(true)}
            >
              + write my own
            </button>
          )}
        </div>
      )}

      {customMode && category.allowCustom && (
        <div className={styles.customRow}>
          <input
            type="text"
            className={styles.input}
            value={currentValue}
            placeholder="write your own..."
            maxLength={120}
            onChange={(e) => onChange(category.key, e.target.value)}
            autoFocus
          />
          <button
            type="button"
            className={styles.customRevert}
            onClick={() => {
              const first = category.options[0];
              if (first) onChange(category.key, first.label);
              setCustomMode(false);
            }}
          >
            back to choices
          </button>
        </div>
      )}
    </fieldset>
  );
}
